<template>
    <div class="deposits-component text-none py-md-6 py-0 px-0 px-md-6 mb-md-10">
      <div class="mobile_header pt-2" v-if="$vuetify.display.mobile">
        <div class="crumb text-left mb-2 mx-4">
          <span @click="openMyAccount">{{ $t('user.my_account_btn') }}</span> / <span class="bold">{{$t('page.deposits_name')}}</span>
        </div>
        

        <div
          class="master_header text-left ml-4 py-4 pt-6"
          v-if="$vuetify.display.mobile"
        >
          {{$t('page.deposits_name')}}
      </div>
      </div>
        <div class="info-wrapper">
          <div v-if="!isLoading && !deposits.length" 
            :class="['info d-flex flex-column justify-center mt-4 mb-2 mx-4 py-12 px-9', $vuetify.display.mobile ? 'mobile' : 'text-left']">
            <div class="header mb-6 mb-md-4">
              {{$t('deposits.list.empty_header')}}
            </div>
            <div class="subheader">
              {{$t('deposits.list.empty_subheader')}}
            </div>
          </div>
          <v-progress-circular
            v-if="isLoading"
            indeterminate
            color="primary"
            :size="50"
            :width="5"
          ></v-progress-circular>
        </div>

        <div v-if="deposits.length" class="deposits-wrapper text-none pa-0 w-100">
          <div v-if="!$vuetify.display.mobile" class="header-row d-flex flex-md-row py-3 px-4 text-left">
            <div class="label">
              {{$t('deposits.list.deposit_number_label')}}
            </div>
            <div class="label">
              {{$t('deposits.list.localization_label')}}
            </div>

            <div class="label">
              {{$t('deposits.list.date_label')}}
            </div>

            <div class="label">
              {{$t('deposits.list.deposit_type_label')}}
            </div>

            <div class="label">
              {{$t('deposits.list.payment_status_label')}}
            </div>

          </div>
          <div 
            v-for="(deposit, index) in deposits"
            :key="index">
              <deposit-component :deposit="deposit"/>
          </div>
        </div>

    </div>
</template>

<script>
import DepositComponent from './DepositComponent.vue';
import axios from "axios";

export default {
    name: "deposits-component",
    components: {
      DepositComponent
    },
    data: () => {
      return {
        deposits: [],
        isLoading: false
      }
    },
    mounted() {
      this.isLoading = true;
      this.init();
      this.$store.dispatch('breadcrumbModule/setRoute', [{
          name: 'breadcrumb.want_to_be_a_parent',
          url: `https://bank.invicta.pl${ this.$t('bank_invicta_path.planning_parenthood') }`,
          absolute: true
        },{
          name: 'breadcrumb.dashboard',
          url: '/dashboard?selected=personal-details'
        },
        {
          name: 'breadcrumb.dashboard_labels.deposits',
          url: ''
        }
      ])
    },
    methods: {
      init() {
        axios.get('/api/person/deposits')
        .then((response) => {
          this.deposits = response.data;
        })
        .catch(err => {
          console.error(err);
        })
        .finally(() => {
          this.isLoading = false;
        })
      },
      openMyAccount() {
        this.$emit('openMyAccount', true);
      },
      goToMedipoint() {
        this.$router.push({
          name: 'redirect',
          params: {
            mode: 'simple',
            pathname: location.pathname,
            url: `${process.env.VUE_APP_MEDIPOINT_URL}/${this.$i18n.locale}/dane-medyczne/depozyty`
          }
        })
      },
    }
}
</script>

<style lang="scss" scoped>

.mobile_header {
  color: red;
  background: $ds-background;
  .master_header {
    @include nsb-gentium-bold;
    width: 100%;
    color: $ds-primary;
    font-size: 28px;
    line-height: 36px; 
  }
}

.deposits-component {
  background: $ds-white;
  // border: 1px solid $nsb-color-3;
  // height: calc(100vh - 180px);
  p {
    @include nsb-font-container;
    font-size: 14px;
    line-height: 21px;
  }
  // v-btn {
  //   @include nsb-font-container;
  //   color: white;
  //   font-size: 16px;
  //   line-height: 24px;
  // }
  .crumb {
    @include nsb-select-option;
    font-size: 12px;
    color: $ds-primary-4 !important;
    .bold {
      @include nsb-select-chip;
      font-size: 12px;
      color: $ds-primary;
    }
  }

  .main-header {
    @include nsb-gentium-bold;
    font-size: 23px;
    line-height: 27px;
  }

  .info-wrapper {
    position: relative;
    .v-progress-circular {
      position: fixed;
      top: 50%;
      z-index: 999;
      transform: translate(-50%,-50%);
    }
    .info{
      height: 350px;
      .header {
        @include nsb-font-header-bold;
        font-size: 20px !important;
        line-height: 30px !important;
      }
      .subheader {
        @include nsb-font-header;
        font-size: 14px !important;
        line-height: 22px !important;
      }
      &.mobile {
        .header {
          font-size: 14px !important;
          line-height: 22px !important;
        }
        .subheader {
          font-size: 12px !important;
          line-height: 18px !important;
        }
      }
    }
  }

  .deposits-wrapper {
    background: $ds-white;

    @include nsb-font-container;
    font-size: 14px;
    line-height: 23px;

    .header-row {
      background: $ds-white;
      border-bottom: 1px solid $ds-primary-300;
      gap: 32px;

      .label {
        @include ds-font-label-medium;
        width: 114px;
      }
    }
  }
}

@media (min-width: 960px) {
  .deposits-component {
    min-height: 716px;
  }
}
</style>